module.exports = __webpack_public_path__ + "img/cloud_light.cace7433.png";